var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip, Dialog, Icon } from '@a-type/ui';
export function Tip(_a) {
    var { content, title } = _a, rest = __rest(_a, ["content", "title"]);
    return (_jsxs(Dialog, { children: [_jsxs(Dialog.Trigger, { render: _jsx(Chip, Object.assign({ color: "accent" }, rest)), children: [_jsx(Icon, { name: "lightbulb" }), _jsx("span", { children: title })] }), _jsxs(Dialog.Content, { children: [_jsx(Dialog.Title, { children: title }), content, _jsx(Dialog.Actions, { children: _jsx(Dialog.Close, { children: "Close" }) })] })] }));
}
//# sourceMappingURL=Tip.js.map